import { createSelector } from "@ngrx/store";
import { State } from "../reducers";

export const selectPaymentState = (state: State) => state.payment;

export const paymentObject = createSelector(
  selectPaymentState,
  payment => payment.paymentObject
);
